const localizers = {
  'loading.msg': () => `ロード中...`,
  'logon.message.msg': () => `認証が必要です。有効なユーザー ID とパスワードを入力してください。`,
  'logon.button.msg': () => `ログイン...`,
  'SASServer.logonError.msg': () => `サーバーにログオンできません。`,
  'SASServer.genericError.msg': () => `サーバーにアクセスできません。`,
}
export default localizers;
